(function () {
  "use strict";

  function initStaticHeaderToggleMenu(root) {
    const scope = root || document;

    const toggleButton = scope.querySelector("[data-toggle-menu-button]");

    const togglePanel = scope.querySelector("[data-toggle-menu-panel]");

    if (!toggleButton || !togglePanel) {
      return;
    }

    if (toggleButton.dataset.staticToggleMenuInitialized === "true") {
      return;
    }

    toggleButton.dataset.staticToggleMenuInitialized = "true";

    function openMenu() {
      togglePanel.classList.add("is-open");

      toggleButton.setAttribute("aria-expanded", "true");

      togglePanel.setAttribute("aria-hidden", "false");
    }

    function closeAllSubmenus(exceptItem) {
      const expandedItems = togglePanel.querySelectorAll(
        ".static-header-toggle-menu__item.is-expanded",
      );

      expandedItems.forEach(function (item) {
        if (item !== exceptItem) {
          item.classList.remove("is-expanded");

          const parentLink = item.querySelector(
            ":scope > .static-header-toggle-menu__link",
          );

          if (parentLink) {
            parentLink.setAttribute("aria-expanded", "false");
          }
        }
      });
    }

    function closeMenu() {
      togglePanel.classList.remove("is-open");

      toggleButton.setAttribute("aria-expanded", "false");

      togglePanel.setAttribute("aria-hidden", "true");

      closeAllSubmenus();
    }

    function toggleMenu(event) {
      event.preventDefault();
      event.stopPropagation();

      if (togglePanel.classList.contains("is-open")) {
        closeMenu();
      } else {
        openMenu();
      }
    }

    toggleButton.addEventListener("click", toggleMenu);

    function handleLevelOneClick(event) {
      if (window.innerWidth > 1024) {
        return;
      }

      const parentLink = event.target.closest("[data-toggle-menu-parent]");

      if (!parentLink) {
        return;
      }

      if (!togglePanel.contains(parentLink)) {
        return;
      }

      const parentItem = parentLink.closest(".static-header-toggle-menu__item");

      if (!parentItem) {
        return;
      }

      const submenu = parentItem.querySelector(
        ":scope > .static-header-toggle-menu__submenu",
      );

      if (!submenu) {
        return;
      }

      const arrow = event.target.closest(".static-header-toggle-menu__arrow");

      if (arrow) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (parentItem.classList.contains("is-expanded")) {
          parentItem.classList.remove("is-expanded");

          parentLink.setAttribute("aria-expanded", "false");
        } else {
          closeAllSubmenus(parentItem);

          parentItem.classList.add("is-expanded");

          parentLink.setAttribute("aria-expanded", "true");
        }

        return;
      }

      if (parentItem.classList.contains("is-expanded")) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      closeAllSubmenus(parentItem);

      parentItem.classList.add("is-expanded");

      parentLink.setAttribute("aria-expanded", "true");
    }

    document.addEventListener("click", handleLevelOneClick, true);

    togglePanel.addEventListener("click", function (event) {
      const submenuLink = event.target.closest(
        ".static-header-toggle-menu__submenu-link, " +
          ".static-header-toggle-menu__third-level-link",
      );

      if (!submenuLink) {
        return;
      }

      closeMenu();
    });

    togglePanel.addEventListener("click", function (event) {
      event.stopPropagation();
    });

    document.addEventListener("click", function (event) {
      if (
        !togglePanel.contains(event.target) &&
        !toggleButton.contains(event.target)
      ) {
        closeMenu();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") {
        return;
      }

      if (!togglePanel.classList.contains("is-open")) {
        return;
      }

      closeMenu();

      toggleButton.focus();
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth > 1024) {
        closeAllSubmenus();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initStaticHeaderToggleMenu();
    });
  } else {
    initStaticHeaderToggleMenu();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initStaticHeaderToggleMenu(event.target);
  });
})();
